import { validateUrl } from "./utils";
import { createPopToken } from "../popToken/createPop";
import axios from 'axios';
import {dynamicKeys} from '../popToken/dynamicKey';

const { VITE_CLIENTID } = typeof import.meta !== 'undefined' ? import.meta.env : process.env;

export const axiosToken = async ({
    method,
    url
  }) => {
    if (!url || typeof url !== 'string') {
      throw new Error('Invalid URL: URL must be a non-empty string');
    }
  
    // Validate the URL to prevent SSRF attacks
    const isValidUrl = validateUrl(url);
    if (!isValidUrl) {
      throw new Error('Invalid URL: SSRF protection - URL not allowed');
    }
    
    const { privateKey, publicKey } = dynamicKeys();
    
    const data = {
      client_id: VITE_CLIENTID,
      cnf: publicKey,
    }

    const pop_token = createPopToken(method, url, null, data, privateKey);
    
    const headers = {
      'X-Authorization': pop_token,
    };
  
    return axios({
      method,
      url,
      data,
      headers,
    });
  };

